<template>
    <div class="callback">
        <processing />
    </div>
</template>

<script lang="ts">
import { unfoldError } from '@/common/js/notice';
import nProgress from 'nprogress';
import Vue from 'vue';
import processing from '@/basic/processing.vue';

export default Vue.extend({
    components:{
        processing
    },
    mounted() {

        nProgress.done();
        this.openReolinkApp();

    },
    methods:{
        openReolinkApp() {

            try {

                const aElement = document.createElement( 'a' );
                
                const currentUrl = new URL( location.href );
                currentUrl.hostname = 'cloud.reolink.com';
                aElement.href = currentUrl.href.replace( 'https', 'reolinkapi' );
                
                aElement.click();
                aElement.remove();

            } catch ( e ) {

                console.error( e );
                unfoldError( 'errors.error_unknown' );

            }

        }
    }
});
</script>

<style lang="less" scoped>
.callback{
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

<style lang="less" scoped>
</style>
